import { FC, Fragment } from 'react'
import {
  SectionArticlesTitle,
} from './styles'
import { QuoteData } from 'src/dtos/applicationData'
import { numberToCurrency } from 'src/utils/numberFormat'
import { IoMdCheckmark } from 'react-icons/io'

interface QuotesSectionProps {
  quotesSection?: QuoteData[];
  isComplete: boolean;
}


const QuotesSection: FC<QuotesSectionProps> = ({ quotesSection, isComplete }) => {
  const handleShowLimits = (limits?: string) => {
    if(!limits) return 'N/A'

    const [perClaim, aggregate] = limits.split(';')
    
    return `${numberToCurrency(Number(perClaim), 0, 0)} per claim / ${numberToCurrency(Number(aggregate), 0, 0)} aggregate`
  }

  return (
    <section id='quotesSection'>
      <header>
        <h4>Select Quote</h4>
        {isComplete ? (
          <h6><IoMdCheckmark/> Complete</h6>
        ) : null}
      </header>
      {(quotesSection && quotesSection.length > 0) ? quotesSection.map((quote, index) => (
        <Fragment key={index}>
          <SectionArticlesTitle style={{ marginBottom: 0 }}>{quote.policyType === 'BASIC' ? 'ESSENTIAL ': 'PREMIER'} POLICY QUOTE</SectionArticlesTitle>
          <article style={{ marginTop: '8px' }}>
            <strong>Limits of Liability</strong>
            <span>{handleShowLimits(quote.liabilityLimits)}</span>
          </article>
          <article style={{ marginTop: '8px' }}>
            <strong>Deductible</strong>
            <span>{quote.deductible ?? 'N/A'}</span>
          </article>
        </Fragment>
      )) : (
        <SectionArticlesTitle style={{ marginBottom: 0 }}>NO QUOTE SELECTED</SectionArticlesTitle>
      )}
    </section>
  )
}

export default QuotesSection